// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let DevicePixelRatio = require("../v5/common/DevicePixelRatio.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_response_addMemberV5(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
    "AccountMemberAdded",
    "NotAuthorizedError",
    "SubuserLimitReachedForAccount"
  ]);
}

let variablesConverter = {"addMemberToAccountInput":{"email":{"b":""}},"__root":{"input":{"r":"addMemberToAccountInput"}}};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

let wrapResponseConverter = {"__root":{"addMemberV5_AccountMemberAdded_addedAccountMember":{"f":""},"addMemberV5":{"u":"response_addMemberV5"}}};

let wrapResponseConverterMap = {
  response_addMemberV5: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

let responseConverter = {"__root":{"addMemberV5_AccountMemberAdded_addedAccountMember":{"f":""},"addMemberV5":{"u":"response_addMemberV5"}}};

let responseConverterMap = {
  response_addMemberV5: unwrap_response_addMemberV5
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

let Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

function accountMemberRoleInput_decode($$enum) {
  if ($$enum === "ASSISTANT" || $$enum === "TRANSACTION_COORDINATOR" || $$enum === "ASSOCIATE" || $$enum === "SHOWING_ASSISTANT" || $$enum === "BUYER_SPECIALIST" || $$enum === "PARTNER" || $$enum === "CLIENT_CARE_COORDINATOR" || $$enum === "OPERATIONS_MANAGER" || $$enum === "INSIDE_SALES_AGENT" || $$enum === "MARKETING_SPECIALIST" || $$enum === "LISTING_MANAGER" || $$enum === "LISTING_SPECIALIST") {
    return $$enum;
  }
}

let accountMemberRoleInput_fromString = accountMemberRoleInput_decode;

let Utils = {
  accountMemberRoleInput_decode: accountMemberRoleInput_decode,
  accountMemberRoleInput_fromString: accountMemberRoleInput_fromString
};

let providedVariablesDefinition = {
  __relay_internal__pv__DevicePixelRatio: {
    providedVariable: DevicePixelRatio.get,
    get: DevicePixelRatio.get
  }
};

function makeNode(providedVariablesDefinition) {
  return ((function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subuserLimitReached",
  "storageKey": null
},
v5 = [
  (v3/*: any*/)
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nodeId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SubusersAddUserForm_AddMemberV5Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "addMemberV5",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountMember",
                "kind": "LinkedField",
                "name": "addedAccountMember",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "SubusersPageAccountsListItem_member"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountV5",
                "kind": "LinkedField",
                "name": "account",
                "plural": false,
                "selections": [
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "AccountMemberAdded",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": (v5/*: any*/),
            "type": "NotAuthorizedError",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": (v5/*: any*/),
            "type": "SubuserLimitReachedForAccount",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__DevicePixelRatio"
      }
    ],
    "kind": "Operation",
    "name": "SubusersAddUserForm_AddMemberV5Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "addMemberV5",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountMember",
                "kind": "LinkedField",
                "name": "addedAccountMember",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "role",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Agent",
                    "kind": "LinkedField",
                    "name": "agent",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProfilePhoto",
                        "kind": "LinkedField",
                        "name": "profilePhoto",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Variable",
                                "name": "ratio",
                                "variableName": "__relay_internal__pv__DevicePixelRatio"
                              },
                              {
                                "kind": "Literal",
                                "name": "width",
                                "value": 60
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "url",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "firstName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lastName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "displayName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "emailAddress",
                        "storageKey": null
                      },
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "appendNode",
                "key": "",
                "kind": "LinkedHandle",
                "name": "addedAccountMember",
                "handleArgs": [
                  {
                    "kind": "Variable",
                    "name": "connections",
                    "variableName": "connections"
                  },
                  {
                    "kind": "Literal",
                    "name": "edgeTypeName",
                    "value": "AccountV5MembersConnectionEdge"
                  }
                ]
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountV5",
                "kind": "LinkedField",
                "name": "account",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v6/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "AccountMemberAdded",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8beb905cc5910fe63882a51d7d4e7042",
    "id": null,
    "metadata": {},
    "name": "SubusersAddUserForm_AddMemberV5Mutation",
    "operationKind": "mutation",
    "text": "mutation SubusersAddUserForm_AddMemberV5Mutation(\n  $input: AddMemberToAccountInput!\n  $__relay_internal__pv__DevicePixelRatio: Float!\n) {\n  addMemberV5(input: $input) {\n    __typename\n    ... on AccountMemberAdded {\n      addedAccountMember {\n        ...SubusersPageAccountsListItem_member\n        nodeId\n      }\n      account {\n        subuserLimitReached\n        nodeId\n      }\n    }\n    ... on NotAuthorizedError {\n      __typename\n    }\n    ... on SubuserLimitReachedForAccount {\n      __typename\n    }\n  }\n}\n\nfragment SubusersPageAccountsListItem_member on AccountMember {\n  id\n  role\n  agent {\n    profilePhoto {\n      url(width: 60, ratio: $__relay_internal__pv__DevicePixelRatio)\n    }\n    firstName\n    lastName\n    displayName\n    emailAddress\n    nodeId\n  }\n}\n",
    "providedVariables": providedVariablesDefinition
  }
};
})());
}

let node = makeNode(providedVariablesDefinition);

let wrap_response_addMemberV5 = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_addMemberV5 = unwrap_response_addMemberV5;
exports.wrap_response_addMemberV5 = wrap_response_addMemberV5;
exports.Internal = Internal;
exports.Utils = Utils;
exports.providedVariablesDefinition = providedVariablesDefinition;
exports.node = node;
/* node Not a pure module */
